import React, { Fragment, useState } from "react"
import { Box, Button, CircularProgress, Typography } from "@material-ui/core"
import {
  toggleClickConfirmationDialog,
  toggleSoloRepresentativeDialog,
} from "../../../../actions/billingDialogs"
import { duplicateSolo, updateSolo } from "../../../../actions/solos"
import { openSnackBar } from "../../../../actions/snack-bar"
import { toggleShootDialog } from "../../../../actions/shoots"
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import useStyles from "./styles"
import ActionBarComponent from "../../../../components/ActionBar/index"
import UpdateSoloRepresentativeDialog from "../../BillingDialogs/UpdateSoloRepresentativeDialog"
import ChangeRepresentativeButton from "../../../ChangeRepresentativeButton/index"
import { Tooltip } from "../../../../../node_modules/@material-ui/core/index"

const SoloHeader = ({
  saveSolo,
  type,
  draftLoading = true,
  dataLoading = false,
  isSent = false,
  soloData,
  setSoloData,
  ...props
}) => {
  const [repLoading, setRepLoading] = useState(false)
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = props.history
  const id = props.match.params.id

  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const activeCompany = useSelector(state => state.companies.activeCompany)

  const openDialog = () => {
    dispatch(toggleShootDialog({ open: true, data: { data: soloData } }))
  }

  const sendDisabled = soloData && soloData.client_id === null

  // *** DUPLICATE SOLO  ***
  const handleDuplicateSolo = () => {
    dispatch(duplicateSolo(type.toLowerCase(), id))
      .then(res => {
        history.push(`/billing/solo-${type.toLowerCase()}/${res.solo_id}`)
        dispatch(
          openSnackBar({
            message: `Successfully duplicated ${type.toLowerCase()}`,
          })
        )
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error creating duplicate" }))
      })
  }

  const openDuplicateConfirmation = () => {
    let dupeData = {
      action: `duplicate this ${capitalizeFirstLetter(type)}`,
      confirmationFunc: handleDuplicateSolo,
      funcArgs: [],
    }
    dispatch(toggleClickConfirmationDialog(true, dupeData))
  }
  // *** DUPLICATE SOLO END ***

  const handleCloseRepresentativeDialog = () => {
    dispatch(toggleSoloRepresentativeDialog(false))
  }

  const onChangeSoloRepresentative = rep => {
    setRepLoading(true)
    const { id: repId, name } = rep
    let callData = { cm_rep_id: repId }
    dispatch(updateSolo(type, id, callData))
      .then(() => {
        setSoloData({
          ...soloData,
          representative_name: name,
          representative_id: repId,
        })
        setRepLoading(false)
        dispatch(
          openSnackBar({ message: "Succesfully changed representative" })
        )
        dispatch(toggleSoloRepresentativeDialog(false))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error changing representative" }))
      })
      .finally(() => {
        setRepLoading(false)
      })
  }

  const handleOpenRepresentativeDialog = () => {
    dispatch(toggleSoloRepresentativeDialog(true))
  }
  return (
    <Fragment>
      <ActionBarComponent
        buttonChildren={() => (
          <Box className={classes.leftContainer}>
            <Box className={classes.leftTitle}>
              {isSent
                ? `${capitalizeFirstLetter(type)}`
                : `New ${capitalizeFirstLetter(type)}`}
            </Box>
            {!dataLoading && (
              <ChangeRepresentativeButton
                repName={
                  soloData.representative_name === null
                    ? soloData.creator_name
                    : soloData.representative_name
                }
                onClickFn={handleOpenRepresentativeDialog}
              />
            )}
          </Box>
        )}
        sortChildren={() => {
          if (dataLoading) {
            return null
          }
          return (
            <Box className={classes.sortChildren}>
              {/* SOLO ESTIMATE ONLY - Either Create Shoot from Solo or Go to the Connected shoot */}
              {type.toLowerCase() === "estimate" && (
                <Box>
                  {/* Only show Create Shoot button if not connected to one currently.
                If connected, show no buttons per CM request */}
                  {!soloData.shoot_id &&
                    !sendDisabled && (
                      <Button onClick={openDialog} className={classes.button}>
                        Create Shoot
                      </Button>
                    )}
                </Box>
              )}
              <Button
                onClick={saveSolo}
                className={classes.button}
                style={isSent ? { width: "64px" } : { width: "120px" }}
              >
                {/* {isSent ? "Save" : "Save as Draft"} */}
                {draftLoading ? (
                  <CircularProgress className={classes.progress} size={20} />
                ) : isSent ? (
                  "Save"
                ) : (
                  "Save as Draft"
                )}
              </Button>
              <Tooltip
                title={sendDisabled ? "Attach a client to solo first" : ""}
              >
                <Box>
                  <Button
                    className={classes.button}
                    onClick={openDuplicateConfirmation}
                    disabled={sendDisabled}
                  >
                    Create Duplicate
                  </Button>
                </Box>
              </Tooltip>
              <Button
                className={classes.button}
                style={{
                  opacity: 1,
                  color: "#9A9A9A",
                }}
                onClick={() => history.push("/billing")}
              >
                Cancel
              </Button>
            </Box>
          )
        }}
      />
      <UpdateSoloRepresentativeDialog
        activeManagerId={(soloData && soloData.representative_id) || null}
        creators={
          authenticatedUser.companies.find(x => x.id === activeCompany)
            ? authenticatedUser.companies.find(x => x.id === activeCompany)
                .managers
            : []
        }
        changeActiveRepresentative={repData =>
          onChangeSoloRepresentative(repData)
        }
        loading={repLoading}
        onClose={handleCloseRepresentativeDialog}
      />
    </Fragment>
  )
}

SoloHeader.propTypes = {
  saveSolo: PropTypes.func,
  type: PropTypes.string,
  draftLoading: PropTypes.bool,
  dataLoading: PropTypes.bool,
  isSent: PropTypes.bool,
  soloData: PropTypes.object,
  setSoloData: PropTypes.func,
}

export default SoloHeader
